const initialState = {
  etoZones: {
    data: [],
    loading: false,
    error: null,
  },
  zonesOfDistrict: {
    data: null,
    loading: false,
    error: null,
  },
  zonesByDistrict: {
    data: null,
    loading: false,
    error: null,
  },
  districtCircles: {
    data: null,
    loading: false,
    error: null,
  },
  highwaysOfDistrict: {
    data: null,
    loading: false,
    error: null,
  },
  assignZonesToETOResponse: {
    data: null,
    loading: false,
    error: null,
  },
  tableValues: {
    data: null,
    loading: false,
    error: null,
  },
  highwayValue: {
    data: null,
    loading: false,
    error: null,
  },
  zoneValue: {
    data: null,
    loading: false,
    error: null,
  },
  districtValue: {
    data: null,
    loading: false,
    error: null,
  }
};

const zonesReducer = (state = initialState, { type, error, payload, data }) => {
  switch (type) {
    case "RESET_ASSIGN_ZONES_TO_ETO":
      return {
        ...state,
        assignZonesToETOResponse: {
          data: null,
          loading: false,
          error: null,
        },
      };
    case "ASSIGN_ZONES_TO_ETO":
      return {
        ...state,
        assignZonesToETOResponse: {
          ...state.assignZonesToETOResponse,
          loading: true,
        },
      };
    case "ASSIGN_ZONES_TO_ETO_SUCCESS":
      return {
        ...state,
        assignZonesToETOResponse: {
          ...state.assignZonesToETOResponse,
          loading: false,
          data: data,
        },
      };
    case "ASSIGN_ZONES_TO_ETO_FAIL":
      return {
        ...state,
        assignZonesToETOResponse: {
          ...state.assignZonesToETOResponse,
          loading: false,
          error,
        },
      };


    case "GET_ALL_ETO_ZONES":
      return {
        ...state,
        etoZones: {
          ...state.etoZones,
          loading: true,
        },
      };
    case "GET_ALL_ETO_ZONES_SUCCESS":
      return {
        ...state,
        etoZones: {
          ...state.etoZones,
          loading: false,
          data: data,
        },
      };
    case "GET_ALL_ETO_ZONES_FAIL":
      return {
        ...state,
        etoZones: {
          ...state.etoZones,
          loading: false,
          error,
        },
      };

    case "GET_ZONES_OF_DISTRICT":
      return {
        ...state,
        zonesOfDistrict: {
          ...state.zonesOfDistrict,
          loading: true,
        },
      };
    case "GET_ZONES_OF_DISTRICT_SUCCESS":
      return {
        ...state,
        zonesOfDistrict: {
          ...state.zonesOfDistrict,
          loading: false,
          data: data,
        },
      };
    case "GET_ZONES_OF_DISTRICT_FAIL":
      return {
        ...state,
        zonesOfDistrict: {
          ...state.zonesOfDistrict,
          loading: false,
          error,
        },
      };
      case "ZONES_BY_DISTRICT":
        return {
          ...state,
          zonesByDistrict: {
            ...state.zonesByDistrict,
            loading: true,
          },
        };
      case "ZONES_BY_DISTRICT_SUCCESS":
        return {
          ...state,
          zonesByDistrict: {
            ...state.zonesByDistrict,
            loading: false,
            data: data,
          },
        };
      case "ZONES_BY_DISTRICT_FAIL":
        return {
          ...state,
          zonesByDistrict: {
            ...state.zonesByDistrict,
            loading: false,
            error,
          },
        };
        case "GET_DISTRICT_CIRCLES":
          return {
            ...state,
            districtCircles: {
              ...state.districtCircles,
              loading: true,
            },
          };
        case "GET_DISTRICT_CIRCLES_SUCCESS":
          return {
            ...state,
            districtCircles: {
              ...state.districtCircles,
              loading: false,
              data: data,
            },
          };
        case "GET_DISTRICT_CIRCLES_FAIL":
          return {
            ...state,
            districtCircles: {
              ...state.districtCircles,
              loading: false,
              error,
            },
          };
          case "GET_HIGHWAYS_OF_DISTRICT":
          return {
            ...state,
            highwaysOfDistrict: {
              ...state.highwaysOfDistrict,
              loading: true,
            },
          };
        case "GET_HIGHWAYS_OF_DISTRICT_SUCCESS":
          return {
            ...state,
            highwaysOfDistrict: {
              ...state.highwaysOfDistrict,
              loading: false,
              data: data,
            },
          };
        case "GET_HIGHWAYS_OF_DISTRICT_FAIL":
          return {
            ...state,
            highwaysOfDistrict: {
              ...state.highwaysOfDistrict,
              loading: false,
              error,
            },
          };
          case "EDIT_TABLE_VALUES":
            return {
              ...state,
              tableValues: {
                ...state.tableValues,
                loading: true,
                data:null,
                error:null
              },
            };
          case "EDIT_TABLE_VALUES_SUCCESS":
            return {
              ...state,
              tableValues: {
                ...state.tableValues,
                loading: false,
                data: data,
                error:null
              },
            };
          case "EDIT_TABLE_VALUES_FAIL":
            return {
              ...state,
              tableValues: {
                ...state.tableValues,
                loading: false,
                error,
              },
            };
          case "EDIT_HIGHWAY_VALUE":
          return {
            ...state,
            highwayValue: {
              ...state.highwayValue,
              loading: true,
              data:null,
              error:null
            },
          };
          case "EDIT_HIGHWAY_VALUE_SUCCESS":
            return {
              ...state,
              highwayValue: {
                ...state.highwayValue,
                loading: false,
                data: data,
                error:null
              },
            };
          case "EDIT_HIGHWAY_VALUE_FAIL":
            return {
              ...state,
              highwayValue: {
                ...state.highwayValue,
                loading: false,
                error,
              },
            };
            case "EDIT_ZONE_VALUE":
            return {
              ...state,
              zoneValue: {
                ...state.zoneValue,
                loading: true,
                data:null,
                error:null
              },
            };
          case "EDIT_ZONE_VALUE_SUCCESS":
            return {
              ...state,
              zoneValue: {
                ...state.zoneValue,
                loading: false,
                data: data,
                error:null
              },
            };
          case "EDIT_ZONE_VALUE_FAIL":
            return {
              ...state,
              zoneValue: {
                ...state.zoneValue,
                loading: false,
                error,
              },
            };
            case "ADD_DISTRICT":
            return {
              ...state,
              districtValue: {
                ...state.districtValue,
                loading: true,
                data:null,
                error:null
              },
            };
          case "ADD_DISTRICT_SUCCESS":
            return {
              ...state,
              districtValue: {
                ...state.districtValue,
                loading: false,
                data: data,
                error:null
              },
            };
          case "ADD_DISTRICT_FAIL":
            return {
              ...state,
              districtValue: {
                ...state.districtValue,
                loading: false,
                error,
              },
            };

    default:
      return state;
  }
};

export default zonesReducer;
